import React from "react";

import BasicNavbar from "./BasicNavbar";
import SiteFooter from "../../components/SiteFooter";

export default function PrivacyPolicyPage() {
  return (
    <div className="dark">
      <div className="bg-background relative flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden overflow-y-auto scroll-smooth">
        <BasicNavbar />
        <main className="relative z-10 flex w-full flex-1 flex-col items-center pt-[calc(6rem+var(--intl-notice-height,0px))] pb-24">
          <section className="w-full max-w-5xl px-6 sm:px-8">
            <h1 className="text-foreground text-2xl font-semibold tracking-tight sm:text-[32px]">
              隐私政策
            </h1>
            <div className="text-default-500 mt-4 space-y-6 text-sm leading-relaxed sm:text-base">
              <p>
                适用对象：本协议适用于上海纽酷信息科技有限公司（以下简称“本公司”）旗下“新核云”与“3Chat”
                两款产品（以下合称“本应用”）及相关功能模块。
              </p>
              <p>
                上海纽酷信息科技有限公司及旗下新核云、3Chat 产品（以下合称“本应用”）尊重并保护所有使用服务用户的个人隐私权，本应用会按照本隐私权政策的规定使用和披露您的个人信息，除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策，您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容，本隐私权政策属于本应用服务使用协议不可分割的一部分。
              </p>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">1. 适用范围</h2>
                <p>
                  (a) 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您移动设备上的信息，包括但不限于您的
                  IP 地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
                </p>
                <p className="mt-2">
                  (b) 本应用通过合法途径从商业伙伴处取得的用户个人数据。
                </p>
                <p className="mt-2">您了解并同意，以下信息不适用本隐私权政策：</p>
                <p className="mt-1">
                  (a) 您在使用本应用平台提供的搜索服务时输入的关键字信息；
                </p>
                <p className="mt-1">
                  (b) 违反法律规定或违反本应用规则行为及本应用已对您采取的措施。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">2. 信息采集</h2>
                <p>
                  本应用使用了如下第三方 SDK，SDK 和应用本身因为功能需要和数据优化会请求相应的设备权限：
                </p>
                <p className="mt-2 font-medium">2.1 引用第三方 SDK 列表：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>
                    (a) <code>com.xiaomi.mipush, com.xiaomi.push</code>（小米推送 SDK）—— 用途：仅在小米手机上支持使用小米推送服务
                  </li>
                  <li>
                    (b) <code>com.huawei.hms, com.huawei.agconnect</code>（华为推送 SDK，华为扫码 SDK）—— 用途：仅在华为手机上支持使用华为推送服务和华为扫码服务
                  </li>
                  <li>
                    (c) <code>com.heytap.msp.push</code>（OPPO 推送 SDK）—— 用途：仅在 OPPO 手机上支持使用 OPPO 推送服务
                  </li>
                  <li>
                    (d) <code>com.vivo.push</code>（VIVO 推送 SDK）—— 用途：仅在 VIVO 手机上支持使用 VIVO 推送服务
                  </li>
                  <li>
                    (e) <code>com.tencent.smtt</code>（腾讯 TBS 浏览器）—— 用途：浏览 PDF、WORD、EXCEL、POWERPOINT 等文档文件
                  </li>
                  <li>
                    (f) <code>com.umeng.+</code>（友盟分析）—— 用途：App 使用数据分析，用于优化 App 使用体验和功能
                  </li>
                  <li>
                    (g) <code>com.amap.api</code>（高德地图）—— 用途：使用地图服务，用于在表单中显示地图和位置
                  </li>
                  <li>
                    (h) <code>com.aliyun</code>（阿里云 ARMS 服务）
                  </li>
                </ul>

                <div className="mt-4 overflow-x-auto rounded-xl border border-default-100/60 bg-default-50/5">
                  <table className="min-w-full border-collapse text-xs text-default-500 sm:text-sm">
                    <thead>
                      <tr className="border-b border-default-100/60 bg-default-100/20 text-left text-foreground">
                        <th className="whitespace-nowrap px-4 py-2 font-medium">名称</th>
                        <th className="whitespace-nowrap px-4 py-2 font-medium">调用目的</th>
                        <th className="whitespace-nowrap px-4 py-2 font-medium">涉及的信息权限</th>
                        <th className="whitespace-nowrap px-4 py-2 font-medium">开发者公司</th>
                        <th className="whitespace-nowrap px-4 py-2 font-medium">第三方隐私政策/开发者协议链接</th>
                      </tr>
                    </thead>
                    <tbody className="align-top">
                      <tr className="border-b border-default-100/60">
                        <td className="px-4 py-2 text-foreground">华为 ScanKit SDK</td>
                        <td className="px-4 py-2">扫码</td>
                        <td className="px-4 py-2">相机/相册</td>
                        <td className="px-4 py-2">华为开发者联盟</td>
                        <td className="px-4 py-2">ScanKit SDK 隐私政策</td>
                      </tr>
                      <tr className="border-b border-default-100/60">
                        <td className="px-4 py-2 text-foreground">友盟 SDK</td>
                        <td className="px-4 py-2">事件跟踪</td>
                        <td className="px-4 py-2">版本号、设备型号、设备操作系统版本、网络状态、网页操作事件</td>
                        <td className="px-4 py-2">友盟+</td>
                        <td className="px-4 py-2">友盟隐私政策</td>
                      </tr>
                      <tr className="border-b border-default-100/60">
                        <td className="px-4 py-2 text-foreground">云片 SDK</td>
                        <td className="px-4 py-2">短信验证/行为验证</td>
                        <td className="px-4 py-2">收集设备号、设备操作系统版本、登录 IP、网络状态</td>
                        <td className="px-4 py-2">云片网</td>
                        <td className="px-4 py-2">云片网隐私政策</td>
                      </tr>
                      <tr className="border-b border-default-100/60">
                        <td className="px-4 py-2 text-foreground">LeanCloud SDK</td>
                        <td className="px-4 py-2">APP 推送</td>
                        <td className="px-4 py-2">收集设备号、设备操作系统版本、登录 IP、网络状态、设备标识码</td>
                        <td className="px-4 py-2">美味书签（北京）信息技术有限公司</td>
                        <td className="px-4 py-2">LeanCloud 隐私协议</td>
                      </tr>
                      <tr className="border-b border-default-100/60">
                        <td className="px-4 py-2 text-foreground">腾讯 TBS 浏览服务</td>
                        <td className="px-4 py-2">网页/文件浏览</td>
                        <td className="px-4 py-2">收集设备号、设备操作系统版本、CPU 类型、网络状态、位置信息、设备标识码、IMSI 等</td>
                        <td className="px-4 py-2">腾讯计算机系统有限公司</td>
                        <td className="px-4 py-2">腾讯浏览服务隐私政策</td>
                      </tr>
                      <tr className="border-b border-default-100/20">
                        <td className="px-4 py-2 text-foreground">高德地图</td>
                        <td className="px-4 py-2">地图服务</td>
                        <td className="px-4 py-2">地理位置</td>
                        <td className="px-4 py-2">阿里巴巴</td>
                        <td className="px-4 py-2">高德隐私政策</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-2 text-foreground">阿里云 ARMS</td>
                        <td className="px-4 py-2">日志服务</td>
                        <td className="px-4 py-2">版本号、设备型号、设备操作系统版本、网络状态、日志信息</td>
                        <td className="px-4 py-2">阿里巴巴</td>
                        <td className="px-4 py-2">阿里云 ARMS SDK 隐私政策</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p className="mt-3 font-medium">2.2 核心设备权限使用说明：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>拨打电话：该权限用于客户拨打售后支持电话</li>
                  <li>读取/写入存储卡内容：该权限用于图片、配置等数据缓存</li>
                  <li>读取通话状态和移动网络信息：该权限由第三方 SDK（见 2.1）使用，用于数据优化</li>
                  <li>读取 IMEI 信息：该权限由第三方 SDK（见 2.1）使用，用于数据优化</li>
                  <li>访问大致位置信息：该权限由第三方 SDK（见 2.1）使用，用于数据优化和地图服务</li>
                  <li>获取设备标识符（Android ID 等）：该权限由第三方 SDK（见 2.1）使用，用于数据优化</li>
                  <li>获取应用基本信息：该权限由第三方 SDK（见 2.1）使用，用于数据优化</li>
                  <li>获取剪切板内容：该权限用于支持文本输入框的“粘贴”功能</li>
                </ul>

                <p className="mt-3 font-medium">2.3 数据存储策略：</p>
                <p>本应用数据有两种存储方式，本地缓存和云端存储：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>本地缓存：只缓存图片、应用配置、登录 Cookie 等信息</li>
                  <li>云端存储：使用本应用过程中所搜集和产生的业务数据，存储在中华人民共和国境内云服务器上</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">3. 信息使用</h2>
                <p>
                  (a) 本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
                </p>
                <p className="mt-2">
                  (b) 本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">4. 信息披露</h2>
                <p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分地披露您的个人信息：</p>
                <p className="mt-2">(a) 经您事先同意，向第三方披露；</p>
                <p>(b) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
                <p>
                  (c) 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；
                </p>
                <p>
                  (d) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
                </p>
                <p>(e) 其它本应用根据法律、法规或者网站政策认为合适的披露。</p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">5. 信息安全</h2>
                <p>
                  (a) 本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用将通过对用户密码进行加密等安全措施确保您的信息不丢失、不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。
                </p>
                <p className="mt-2">
                  (b) 您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">6. 账号注销</h2>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>
                    如果您要注销个人账号时，请联系您所在企业的管理员为您执行注销操作，注销操作立即生效，完成个人账号注销后，本企业的管理员依旧可以访问该账号产生的数据。
                  </li>
                  <li>
                    如果您要注销企业账号时，请联系上海纽酷信息科技有限公司客户经理，在完成注销账号相关手续后，为您执行注销操作，注销操作立即生效，完成企业账号注销后，该企业的所有数据将被冻结不可访问。
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">7. 本隐私政策的更改</h2>
                <p>
                  (a) 如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。
                </p>
                <p className="mt-2">
                  (b) 本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。
                </p>
                <p className="mt-4">本声明自更新之日起生效</p>
                <p>最近的更新日期: 2023 年 05 月 24 日</p>
                <p>上海纽酷信息科技有限公司</p>
                <p>邮箱: developer@xinheyun.com</p>
              </section>
            </div>
          </section>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}

